import React from "react";
import Link from 'gatsby-link';
import styles from './index.module.css';

export default ({ data }) => {
  const edges = data.allMarkdownRemark.edges;
  const latest = edges.slice(edges.length - 4).map(edge =>
    <section key={edge.node.frontmatter.title} className={styles.featuredPanel} >
      <h2><Link className={styles.pageLink} to={edge.node.fields.slug}>
        {edge.node.frontmatter.title}
      </Link></h2>
      <p>{'Released ' + edge.node.frontmatter.date}</p>
      <div dangerouslySetInnerHTML={{__html: edge.node.html}} />
    </section>
  );
  const films = edges.reverse().map(edge =>
    <section key={edge.node.frontmatter.title} className={styles.panel} >
      <h2><Link className={styles.pageLink} to={edge.node.fields.slug}>
        {edge.node.frontmatter.title}
      </Link></h2>
      <p>{'Released ' + edge.node.frontmatter.date}</p>
    </section>
  );
  return (
    <div>
      <div className={styles.title} >
        <h1>Meerkat tested, meerkat approved</h1>
      </div>
      <h1>Latest films</h1>
      <div className={styles.panelWrap} >
        {latest}
      </div>
      <h1>All films</h1>
      <div className={styles.allPanelWrap} >
        {films}
      </div>
    </div>
  );
}

export const query =graphql`
  query HomeQuery {
    allMarkdownRemark(
      sort: {fields: [frontmatter___date], order: ASC}
      filter: {
        fields: { slug: { regex: "/films/" } }
      }
    ) {
      edges {
        node {
          html
          frontmatter {
            title
            date(formatString: "MMMM D, YYYY")
          }
          fields {
            slug
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js